<template>
  <div class="qrcode">
    <h2>Qrcode</h2>
    <el-form :model="this" label-position="left" label-width="50px">
    
      <el-input class="input" placeholder="Wpisz tekst" v-model="text" @input="generate"></el-input>

      <el-row type="flex">
        <el-col>
          <el-form-item label="Kolor">
            <el-color-picker v-model="darkColor" color-format="hex" @change="generate"></el-color-picker>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item label="Tło">
            <el-color-picker v-model="lightColor" color-format="hex" @change="generate"></el-color-picker>
          </el-form-item>
        </el-col>
      </el-row>

    </el-form>

    <div v-if="showPreview" class="preview">
      Podgląd:
      <img :src="qrcode" />
    </div>

    <el-button v-if="showPreview" class="button" type="primary" @click="insert">Wstaw</el-button>
  </div>
</template>

<script>
  import QRCode from 'qrcode'
  import Editor from '../../classes/Editor'

  export default {
    data() {
      return {
        text: '',
        qrcode: '',
        darkColor: '#000',
        lightColor: '#fff',
      }
    },
    computed: {
      showPreview() {
        return this.text && this.qrcode
      }
    },
    methods: {
      async insert() {
        Editor.addSvg(this.qrcode, 'qrcode')
      },
      async generate() {

        if (!this.text) {
          return
        }

        const qrcode = await QRCode.toString(this.text, { 
          type: 'image/svg',
          margin: 2,
          color: {
            dark: this.darkColor,
            light: this.lightColor
          }
        })

        const svgBase64 = btoa(qrcode);
        this.qrcode = `data:image/svg+xml;base64,${svgBase64}`

      }
    }
  }
</script>

<style lang="less" scoped>

.input {
  margin-bottom: 20px;
}

.el-form-item {
  margin-bottom: 0;
}

.button {
  width: 100%;
}

.preview {
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-bottom: 20px;
  font-size: 14px;
  img {
    margin-top: 15px;
    max-width: 80%;
    align-self: center;
  }
}
</style>
